export default __webpack_public_path__ + "28220d9e20d82ba1273bb57efc1ad5f6.svg";